// extracted by mini-css-extract-plugin
export default {"contactSection":"Contact_contactSection__xSvNA","sectionTitle":"Contact_sectionTitle__SaYkK","description":"Contact_description__l1J78","email":"Contact_email__3GBj0"};